import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class DirectionModification extends ShadowDOMElement {
	static className = "DirectionModification";
	
	static properties = {
		id: { type: String },
		validationRequired: { 
			type: Boolean, 
			attribute: "validation-required",
			converter: {
				fromAttribute: (value) => value === "false" ? false : true,
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
		super();
		this.id = "direction-modification";
		this.validationRequired = true;
	}

	render() {
		return html`
			<div id="${this.id || ''}">
				<transformation-list
					id="president"
					title="Direction / Président du conseil d'administration"
					validation-text="Vous devez choisir au moins un type de dirigeant : Président du conseil d'administration / Directeur Général / Directeur général délégué"
					validation-required="false"
				></transformation-list>

				<transformation-list
					id="director"
					title="Direction / Directeur général"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
				></transformation-list>

				<transformation-list
					id="director-delegate"
					title="Direction / Directeur général délégué"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
				></transformation-list>
			</div>
		`;
	}

	isTransient() {
		return false;
	}

	getValues() {
		return {
			...super.getValues()
		}
	}

	setValues(values) {
		super.setValues(values);
	}

	validate() {
		// Remove previous validation messages from parent component
		this.shadowRoot.querySelectorAll('.validation-error-message').forEach(el => el.remove());

		// If validation is not required, always return true
		if (!this.validationRequired) {
			return true;
		}

		// Get all transformation-list components
		const directionComponents = this.shadowRoot.querySelectorAll('transformation-list');
		
		// Check if at least one checkbox is marked in any transformation-list
		let hasChecked = false;
		
		for (const directionComponent of directionComponents) {
			const checkboxes = directionComponent?.shadowRoot?.querySelectorAll('checkbox-field');
			if (checkboxes) {
				const componentHasChecked = Array.from(checkboxes).some(cb => !!cb.checked);
				if (componentHasChecked) {
					hasChecked = true;
					break;
				}
			}
		}

		// If at least one checkbox is marked across all components, it's valid
		if (hasChecked) {
			return true;
		}

		// If no checkbox is marked, show error
		this.showValidationError();

		return false;
	}

	showValidationError() {
		const errorDiv = document.createElement('div');
		errorDiv.className = 'validation-error-message text-danger d-flex align-items-center mb-3';
		errorDiv.style.paddingLeft = '0px';

		const icon = document.createElement('i');
		icon.className = 'fa-solid fa-circle-exclamation me-2';
		icon.setAttribute('aria-hidden', 'true');

		const text = document.createElement('span');
		text.textContent = 'Vous devez choisir au moins un type de dirigeant : Président du conseil d\'administration / Directeur Général / Directeur général délégué';

		errorDiv.appendChild(icon);
		errorDiv.appendChild(text);

		// Insert the message at the beginning of the main container
		const container = this.shadowRoot.querySelector('div');
		if (container && container.firstChild) {
			container.insertBefore(errorDiv, container.firstChild);
		}
	}
}

customElements.define("direction-modification", DirectionModification);
